import moment, { Moment } from 'moment';
import { BankType, NegotiationOption, SettingNameType, useGetSettingQuery } from '../generated/graphql';

const minPaymentDate = moment().startOf('day');
const endOfMonth = moment().endOf('month');

export const useGetPaymentDates = (
  bank = BankType.BancoDavivienda,
  option?: NegotiationOption,
): { minPaymentDate: Moment, maxPaymentDate: Moment } => {
  const { data: finalAssignmentDateData } = useGetSettingQuery({
    variables: { name: SettingNameType.FinalAssignmentDate },
  });

  if (option?.settings?.maxPaymentDate) {
    return {
      minPaymentDate,
      maxPaymentDate: moment(option?.settings?.maxPaymentDate),
    };
  }

  const maxDateSettings = finalAssignmentDateData?.setting?.finalAssignmentDate
    ?.find((s) => bank === s.bank)?.maxValidPaymentDate;
  const maxDateSettingsMoment = moment(maxDateSettings);
  const validSettings = maxDateSettings && maxDateSettingsMoment.isValid()
    && maxDateSettingsMoment.isAfter(minPaymentDate);

  const maxPaymentDate = validSettings ? maxDateSettingsMoment : endOfMonth;

  return { minPaymentDate, maxPaymentDate };
};
